/* eslint 'consistent-return':0 */
export default angular.module('BaseClass.validatable.validationFn',[])
    .factory('BCValidationFn', function() {
        function ValidationFn(validationFn, options) {
            var fn = _.bind(validationFn, options);
            fn.message = configureMessage();
            fn.validator = options.name;

            function configureMessage() {
                if (_.isString(options.message)) return options.message;
                if (_.isFunction(options.message)) return options.message.apply(options);
            }

            return fn;
        }

        return ValidationFn;
    }).name;
